import { render, staticRenderFns } from "./breadcrumb.vue?vue&type=template&id=6a72d28c&scoped=true"
import script from "./breadcrumb.vue?vue&type=script&lang=ts"
export * from "./breadcrumb.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./breadcrumb.vue?vue&type=style&index=0&id=6a72d28c&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "6a72d28c",
  "72c0b2bd"
  
)

export default component.exports